import { UserInformation } from "../models/UserInformation";
import { JsonDecodeUser } from "../models/JsonDecodeUser";
import { checkExp } from "../modules/common"

export function parseJwt(token: string) {
    const base64Url: string = token.split('.')[1];
    const base64: string = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload: JsonDecodeUser = JSON.parse(
        decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return (
                        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                    );
                })
                .join('')
        )
    );

    return jsonPayload;
}

type AccessTokenOptions = {
    replaceOldToken: boolean;
}

export function extractAccessToken(token?: string, options?: AccessTokenOptions): UserInformation {
    if (token && !token.includes('access_token')) {
        token = JSON.stringify({ access_token: token });
    }

    const auth = token ?? localStorage.getItem('DMS_APPLICATION');

    if (!auth) {
        return {} as UserInformation;
    }

    const credentials = JSON.parse(auth);
    const accessToken = credentials.access_token;
    const jwt = parseJwt(accessToken);
    const extra = JSON.parse(jwt.extra);

    checkExp(jwt);

    if (token && options?.replaceOldToken) {
        localStorage.setItem('DMS_APPLICATION', token);
    }

    return extra;
}